import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "border-2 border-pink-300 w-16 h-16 rounded-full p-1 flex items-center justify-center" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", { class: "appFont" }, "Read more", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FullScreenIcon = _resolveComponent("FullScreenIcon")!
  const _component_ItemWrap = _resolveComponent("ItemWrap")!

  return (_openBlock(), _createBlock(_component_ItemWrap, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_FullScreenIcon, { class: "fa-2x" })
      ]),
      _hoisted_2
    ]),
    _: 1
  }))
}